export const BezoekAanSpecialistOption = {
    ja: 'Ja',
    nee: 'Nee',
    zieBeleid: 'Zie beleid',
} as const;

export type BezoekAanSpecialistOption = (typeof BezoekAanSpecialistOption)[keyof typeof BezoekAanSpecialistOption];
